var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgModelClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "50D29B66-E8CF-4377-90EF-F211CE2F445D@3.00x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Customer-Search-and-Profile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "06_Customer-Profile_Group-Summary",
    transform: "translate(-1122.000000, -125.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "popup",
    transform: "translate(184.000000, 80.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outlined-/-Navigation-/-close",
    transform: "translate(933.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\uD83D\\uDD39-Icon-Color",
    fill: "#4A5052",
    fillRule: "evenodd",
    points: "19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModelClose);
export default __webpack_public_path__ + "static/media/model-close.938aefcf1184bc6968fe0743d9fc28d2.svg";
export { ForwardRef as ReactComponent };